import { describeRequiredPermissions } from './tile-config';
import type { CommandDashboardTileDefinition } from './tile-config';

import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import LockOutlined from '@mui/icons-material/LockOutlined';

interface TileInsufficientAccessNoticeProps {
  tile: CommandDashboardTileDefinition;
}

/**
 * Shown in place of a tile's data when the viewer lacks the permission that
 * data requires. The tile itself (header, remove/view actions) stays intact -
 * only the body is replaced, so the tile remains visible rather than
 * disappearing from the dashboard.
 */
export default function TileInsufficientAccessNotice({
  tile,
}: TileInsufficientAccessNoticeProps) {
  return (
    <Stack
      spacing={1}
      alignItems="center"
      justifyContent="center"
      sx={{ py: 4, px: 2, textAlign: 'center' }}
    >
      <LockOutlined color="disabled" />
      <Typography variant="body2" color="text.secondary">
        {`You need "${describeRequiredPermissions(
          tile
        )}" access to view this data.`}
      </Typography>
    </Stack>
  );
}
